import React from "react";
import MainAppGenericModal from "../../../../atoms/Modals/GenericModal";

import styles from "./MainApp.organisms.Product.Modals.SingleLoadExitModal.module.scss";
import i18n from "i18n";

export class SingleLoadExitModal extends React.Component {
  render() {
    const {
      open,
      handleClose
    } = this.props;

    const content = (<div className={styles["single-load-exit-modal-wrapper"]}>
      <div className={styles["single-load-exit-modal-title"]}>{i18n.t("exit.question.message")}</div>
      <div className={styles["single-load-exit-modal-text"]}>{i18n.t("exit.question.message.sub")}</div>
      <div className={styles["single-load-exit-modal-buttons"]}>
        <div className={styles["single-load-exit-modal-button"]} onClick={this.props.cancel} data-automation-id="modal-cancel">{i18n.t("stay")}</div>
        <div className={styles["single-load-exit-modal-button"]} onClick={this.props.confirm} data-automation-id="modal-confirm">{i18n.t("exit.confirmation")}</div>
      </div>
    </div>)
    return (
      <div className={styles["single-load-exit-modal-container"]}>
          <MainAppGenericModal open={open} content={content} handleClose={handleClose}></MainAppGenericModal>
      </div>
    );
  }
}

SingleLoadExitModal.propTypes = {
};

export default SingleLoadExitModal;
